import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classnames from 'classnames';
import { message } from 'antd';
import xss from 'xss';

import { addComment, getCommentList, getGrade } from '../../actions/comment';
import { byteLength, addClass, changeClass, removeClass } from '../../utils/utils';
import styles from './DetailComment.module.less';
import { logging } from '../../actions/log';
import success from '../../static/msg-success.svg';
import fail from '../../static/msg-fail.svg';

const selectAddComment = createSelector(
  state => state.comment,
  comment => comment.addComment,
);

const selectGrade = createSelector(
  state => state.comment,
  comment => comment.grade,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ appDetailsData, text = '我的评分', source, maxLength = 800 }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const addCommentRet = useSelector(selectAddComment);
  const logInfoData = useSelector(selectLogInfo);
  const gradeInfo = useSelector(selectGrade);

  const [value, setValue] = useState(''); // 评论内容
  const [starNum, setStarNum] = useState(0); // 点击选中的评分
  const [hoverStarNum, setHoverStarNum] = useState(0); // hover选中的评分
  const [isNoValue, setIsNoValue] = useState(null);

  const [bizIdentity, setBizIdentity] = useState('');
  const [isSubmitLogin, setIsSubmitLogin] = useState(false);
  const [defaulTextArr, setDefaulText] = useState([]);
  const [guideMessage, setGuideMessage] = useState(''); // 默认引导语

  const guideRef = useRef(null);
  const textAreaRef = useRef(null);

  const guideMsg = {
    '1': '详细说说差评原因？帮更多用户避雷',
    '2': '软件不好用？具体描述下，帮助它做的更好！',
    '3': '还有进步空间？具体描述下，帮助它做的更好！',
    '4': '软件还不错？详细说说，让更多用户了解它！',
    '5': '软件值得推荐？夸奖一下吧，让更多用户种草它！',
  };

  /**
   * 初始化处理默认值
   */
  useEffect(() => {
    if (gradeInfo && gradeInfo.defaulCommentMap && gradeInfo.bizIdentity) {
      let textArr = [];
      if (gradeInfo.defaulCommentMap['1'] && gradeInfo.defaulCommentMap['1'].length > 0) {
        textArr = [...textArr, ...gradeInfo.defaulCommentMap['1']];
      }
      if (gradeInfo.defaulCommentMap['2'] && gradeInfo.defaulCommentMap['2'].length > 0) {
        textArr = [...textArr, ...gradeInfo.defaulCommentMap['2']];
      }
      if (gradeInfo.defaulCommentMap['3'] && gradeInfo.defaulCommentMap['3'].length > 0) {
        textArr = [...textArr, ...gradeInfo.defaulCommentMap['3']];
      }
      if (gradeInfo.defaulCommentMap['4'] && gradeInfo.defaulCommentMap['4'].length > 0) {
        textArr = [...textArr, ...gradeInfo.defaulCommentMap['4']];
      }
      if (gradeInfo.defaulCommentMap['5'] && gradeInfo.defaulCommentMap['5'].length > 0) {
        textArr = [...textArr, ...gradeInfo.defaulCommentMap['5']];
      }
      setDefaulText(textArr);
    } else {
      let bizIdentitys = '';
      if (source === 'zt') {
        bizIdentitys = appDetailsData.ztCommentId;
      } else {
        bizIdentitys =
          appDetailsData.androidType === '1' ? appDetailsData.packageName : appDetailsData.softID;
        dispatch(
          getGrade({
            bizIdentity: bizIdentitys,
          }),
        );
      }
    }
  }, [gradeInfo]);

  /**
   * 初始化处理
   */
  useEffect(() => {
    let bizIdentityStr = '';
    if (source === 'zt') {
      bizIdentityStr = appDetailsData.ztCommentId;
    } else {
      bizIdentityStr =
        appDetailsData.androidType === '1' ? appDetailsData.packageName : appDetailsData.softID;
    }

    setBizIdentity(bizIdentityStr);
  });

  /**
   * 评论结束处理
   */
  useEffect(() => {
    // 评论成功，重新获取当前页面的列表
    let bizIdentityStr = '';
    if (source === 'zt') {
      bizIdentityStr = appDetailsData.ztCommentId;
    } else {
      bizIdentityStr =
        appDetailsData.androidType === '1' ? appDetailsData.packageName : appDetailsData.softID;
    }
    if (
      addCommentRet &&
      !addCommentRet.inLoadding &&
      addCommentRet.bizIdentity === bizIdentityStr
    ) {
      if (addCommentRet.status === 0) {
        updateListScore();
        setValue('');
        setStarNum(0);
        setHoverStarNum(0);
        setIsNoValue(null);
      } else if (addCommentRet.status === 200201 || addCommentRet.status === 400204) {
        updateListScore();
      }

      // 成功还是失败
      if (source === 'zt') {
        dispatch(
          logging({
            category: 'C',
            action: 'Special_Comment_Result',
            label: '',
            param2: {
              source: `Special`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              ztId: appDetailsData.ztId,
              status: addCommentRet.status === 0 ? 1 : 0,
            },
          }),
        );
      } else {
        dispatch(
          logging({
            category: 'C',
            action: 'Comment_Result',
            label: '',
            param2: {
              source: 'AppDetail||Comment',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              starNum,
              isDefaultValue: isDefaultValue(),
              status: addCommentRet.status === 0 ? 1 : 0,
              softId: bizIdentity,
              softType: appDetailsData.androidType ? '1' : '0',
            },
          }),
        );
      }
    }
  }, [addCommentRet]);

  /**
   * 登录成功后继续提交信息
   */
  useEffect(() => {
    if (isSubmitLogin === true) {
      const login_status = window.CallNativeMethod('get_login_status');
      if (login_status === '1' && userInfo.st) {
        handleSubmit();
        setIsSubmitLogin(false);
      }
    }
  }, [userInfo, isSubmitLogin]);

  /**
   * 根据输入框内容变化二显示不同的引导语
   */
  useEffect(() => {
    if (defaulTextArr.indexOf(value) > -1) {
      setGuideMessage(guideMsg[starNum]);
      const guidefDom = guideRef.current;
      guidefDom.style.display = 'block';
      changeClass(guidefDom, styles.fade_in, styles.fade_out);
    } else {
      setGuideMessage('');
      const guidefDom = guideRef.current;
      guidefDom.style.display = 'none';
      changeClass(guidefDom, styles.fade_out, styles.fade_in);
    }
  }, [defaulTextArr, guideRef, value, starNum]);

  const updateListScore = useCallback(() => {
    if (bizIdentity) {
      dispatch(
        getCommentList({
          bizIdentity,
          count: 20,
          orderBy: 'DATE',
          startIndex: 1,
        }),
      );
      dispatch(getGrade({ bizIdentity }));
    }
  }, [dispatch, bizIdentity]);

  const handleSubmit = useCallback(() => {
    // 设置显示
    setIsNoValue(false);
    // 验证内容
    if (!value) {
      setIsNoValue(true);
      // message.info('评论内容不能为空');
      message.error({
        content: '评论内容不能为空',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
      });
      return;
    }
    if (byteLength(value) > maxLength) {
      // message.info('输入内容超过最大字数');
      message.error({
        content: '输入内容超过最大字数',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
      });
      return;
    }
    if (source !== 'zt' && starNum < 1 && Number(gradeInfo.userGrade) < 1) {
      // message.info('点亮评分后可发表');
      message.error({
        content: '点亮评分后可发表',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
      });
      return;
    }
    if (addCommentRet.inLoadding === true) {
      // message.info('正在提交，请勿重复提交');
      message.error({
        content: '正在提交，请勿重复提交',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
      });
      return;
    }
    // 获取用户是否登录
    const login_status = window.CallNativeMethod('get_login_status');
    if (login_status === '1') {
      dispatch(
        addComment({
          bizIdentity,
          content: encodeURIComponent(xss(value)),
          grade: source !== 'zt' ? starNum || Number(gradeInfo.userGrade) : 5, // 专题页面无评分，传任意分数
        }),
      );

      // 点击 评论
      if (source === 'zt') {
        dispatch(
          logging({
            category: 'C',
            action: 'Special_Comment',
            label: '',
            param2: {
              source: `Special`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              ztId: appDetailsData.ztId,
            },
          }),
        );
      } else {
        dispatch(
          logging({
            category: 'C',
            action: 'Comment',
            label: '',
            param2: {
              source: 'AppDetail||Comment',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              starNum,
              isDefaultValue: isDefaultValue(value),
              softId: bizIdentity,
              softType: appDetailsData.androidType ? '1' : '0',
            },
          }),
        );
      }
    } else {
      // 未登录，弹出登录框
      window.CallNativeMethod('login');
      setIsSubmitLogin(true);
      // 点击 登录
      dispatch(
        logging({
          category: 'C',
          action: 'Login',
          label: '',
          param2: {
            source: source === 'zt' ? `Special` : 'AppDetail||Comment',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softId: source === 'zt' ? appDetailsData.ztId : bizIdentity,
            softType: appDetailsData.androidType ? '1' : '0',
          },
        }),
      );
    }
  }, [dispatch, logInfoData, addCommentRet, value, starNum, bizIdentity]);

  const isDefaultValue = useCallback(
    vlaueText => {
      const valueStr = vlaueText || value;
      return defaulTextArr.indexOf(valueStr) > -1 ? 1 : 0;
    },
    [defaulTextArr, value],
  );

  // 输入框内容变化
  const handleTextareaChange = useCallback(
    ev => {
      ev.persist();
      setValue(ev.target.value || '');
    },
    [starNum],
  );

  // 鼠标进入输入框
  const handleTextareaFocus = useCallback(ev => {
    ev.persist();
    setIsNoValue(false);
  }, []);

  const handleGuideMsg = useCallback(
    ev => {
      if (textAreaRef && textAreaRef.current) {
        textAreaRef.current.focus();
      }
    },
    [textAreaRef],
  );

  // 鼠标点击星星
  const handleStar = useCallback(
    (num, vlaueText = '') => {
      if (!vlaueText || vlaueText === '' || isDefaultValue(vlaueText)) {
        const dtextArr = gradeInfo.defaulCommentMap[num] || [];
        const dtext = dtextArr[Math.floor(Math.random() * dtextArr.length)];
        setValue(dtext);

        if (guideMsg[num] && guideRef && guideRef.current) {
          setGuideMessage(guideMsg[num]);
          const guidefDom = guideRef.current;
          guidefDom.style.display = 'block';
          changeClass(guidefDom, styles.fade_in, styles.fade_out);
        }
      }
      setStarNum(num);
      setIsNoValue(false);
    },
    [gradeInfo, defaulTextArr, guideRef],
  );

  // 鼠标hover离开星星
  const onOutStar = useCallback(() => {
    setHoverStarNum(0);
  }, []);

  // 鼠标hover进入星星
  const onHoverStar = useCallback(num => {
    setHoverStarNum(num);
  }, []);

  return (
    <div className={styles.detail_comment}>
      <div className={styles.comment_info_box}>
        <div className={styles.comment_info_box_text}>{text || '我的评分'}</div>
        {source !== 'zt' && (
          <>
            <div
              className={styles.comment_info_box_stars}
              onMouseOut={() => {
                onOutStar();
              }}
              onBlur={() => undefined}
            >
              <span
                className={classnames(
                  'star',
                  'iconfont',
                  starNum >= 1 ||
                    hoverStarNum >= 1 ||
                    (starNum === 0 && gradeInfo && parseInt(gradeInfo.userGrade) >= 1)
                    ? 'icon-staron'
                    : 'icon-star',
                )}
                onMouseOver={() => {
                  onHoverStar(1);
                }}
                onFocus={() => undefined}
                onClick={() => {
                  handleStar(1, value);
                }}
              />
              <span
                className={classnames(
                  'star',
                  'iconfont',
                  starNum >= 2 ||
                    hoverStarNum >= 2 ||
                    (starNum === 0 && gradeInfo && parseInt(gradeInfo.userGrade) >= 2)
                    ? 'icon-staron'
                    : 'icon-star',
                )}
                onMouseOver={() => {
                  onHoverStar(2);
                }}
                onFocus={() => undefined}
                onClick={() => {
                  handleStar(2, value);
                }}
              />
              <span
                className={classnames(
                  'star',
                  'iconfont',
                  starNum >= 3 ||
                    hoverStarNum >= 3 ||
                    (starNum === 0 && gradeInfo && parseInt(gradeInfo.userGrade) >= 3)
                    ? 'icon-staron'
                    : 'icon-star',
                )}
                onMouseOver={() => {
                  onHoverStar(3);
                }}
                onFocus={() => undefined}
                onClick={() => {
                  handleStar(3, value);
                }}
              />
              <span
                className={classnames(
                  'star',
                  'iconfont',
                  starNum >= 4 ||
                    hoverStarNum >= 4 ||
                    (starNum === 0 && gradeInfo && parseInt(gradeInfo.userGrade) >= 4)
                    ? 'icon-staron'
                    : 'icon-star',
                )}
                onMouseOver={() => {
                  onHoverStar(4);
                }}
                onFocus={() => undefined}
                onClick={() => {
                  handleStar(4, value);
                }}
              />
              <span
                className={classnames(
                  'star',
                  'iconfont',
                  starNum >= 5 ||
                    hoverStarNum >= 5 ||
                    (starNum === 0 && gradeInfo && parseInt(gradeInfo.userGrade) >= 5)
                    ? 'icon-staron'
                    : 'icon-star',
                )}
                onMouseOver={() => {
                  onHoverStar(5);
                }}
                onFocus={() => undefined}
                onClick={() => {
                  handleStar(5, value);
                }}
              />
            </div>
            <div className={styles.comment_info_box_desc}>
              {starNum > 0 || gradeInfo.userGrade
                ? `${starNum || gradeInfo.userGrade}分`
                : `暂未评分`}
            </div>
          </>
        )}
      </div>
      <div className={styles.comment_textarea_box}>
        <textarea
          className={isNoValue === true ? styles.comment_textarea_red : styles.comment_textarea}
          placeholder="写点评价吧，你的鼓励是我们持续改进的动力！"
          onChange={handleTextareaChange}
          onFocus={handleTextareaFocus}
          value={value}
          ref={textAreaRef}
        />
        <div className={styles.comment_textarea_guide_msg} ref={guideRef} onClick={handleGuideMsg}>
          {guideMessage}
        </div>
        <div className={styles.comment_textarea_num}>
          <span className={byteLength(value) > maxLength ? styles.textarea_num_max : ''}>
            {byteLength(value)}
          </span>
          <span> / {maxLength}</span>
        </div>
      </div>
      <div
        className={
          addCommentRet.inLoadding === true || value === '' ? styles.submit_grey : styles.submit
        }
        onClick={() => {
          handleSubmit();
        }}
      >
        发表
      </div>
    </div>
  );
});
